var _desc, _rect, _rect2, _rect3, _line, _line2, _line3, _line4, _line5, _line6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBibleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Bible Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Bible book icon for scripture and study")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 20,
    width: 50,
    height: 60,
    rx: 3,
    fill: "#F5F0E6",
    stroke: "#E5DECF",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 22,
    width: 46,
    height: 56,
    rx: 2,
    fill: "white",
    stroke: "#E5DECF",
    strokeWidth: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 20,
    width: 8,
    height: 60,
    rx: 3,
    fill: "#E5DECF"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 35,
    y1: 35,
    x2: 65,
    y2: 35,
    stroke: "#5F7A61",
    strokeWidth: 1
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 35,
    y1: 42,
    x2: 60,
    y2: 42,
    stroke: "#5F7A61",
    strokeWidth: 1
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 35,
    y1: 49,
    x2: 65,
    y2: 49,
    stroke: "#5F7A61",
    strokeWidth: 1
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 35,
    y1: 56,
    x2: 55,
    y2: 56,
    stroke: "#5F7A61",
    strokeWidth: 1
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 30,
    x2: 50,
    y2: 40,
    stroke: "#5F7A61",
    strokeWidth: 2
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 45,
    y1: 35,
    x2: 55,
    y2: 35,
    stroke: "#5F7A61",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBibleIcon);
export default __webpack_public_path__ + "static/media/bible-icon.9469170c0cca96e9b7c0abcede5fa8bb.svg";
export { ForwardRef as ReactComponent };